/**
 * @param {Object} line  an object representing an order/cart line
 * @return {Number} the number of bottles that has to be charged
 */
export default line => {
  if (line.availability && !line.availability) {
    return 0;
  }

  let freeBtls = 0;

  if (line.offer && line.offer.products_number_free) {
    freeBtls = Math.floor(line.quantity / (line.offer.products_number + line.offer.products_number_free)) * line.offer.products_number_free;
  }

  return line.quantity - freeBtls;
};
